/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum DsMatchSummaryStatus {
  Requested = "Requested",
  Received = "Received",
  Failed = "Failed",
}

export const DsMatchSummaryStatusDisplay: Record<DsMatchSummaryStatus, string> = {
  [DsMatchSummaryStatus.Requested]: "Requested",
  [DsMatchSummaryStatus.Received]: "Received",
  [DsMatchSummaryStatus.Failed]: "Failed",
};
